export default {
  "name": "NCInput",
  "column": 1,
  "canAppend": false,
  "type": 1,
  "path": "LowCodeComponents.NCInput",
  "label": "文本框",
  "schema": {
    "type": "object",
    "properties": {
      "moduleId": {
        "title": "区域编码",
        "description": "组件标识",
        "type": "string"
      },
      "className": {
        "title": "className",
        "description": "样式",
        "type": "string"
      },
      "showStar": {
        "title": "必填标识",
        "description": "必填标识",
        "type": "boolean"
      },
      "fieldid": {
        "title": "自动化Id",
        "description": "自动化Id",
        "type": "string"
      }
    },
    "required": [
      "moduleId"
    ]
  },
  "uiSchema": {},
  "slots": []
}